"use client";

import AfaSearchInput from "@afa-shared/afa-components/dist/Inputs/SearchInput";
import { parseAsInteger, parseAsString, useQueryState } from "nuqs";
import { ChangeEvent } from "react";

export default function SearchInput() {
  const [queryValue, setQueryValue] = useQueryState("query", parseAsString.withDefault(""));
  const [_, setPageValue] = useQueryState(
    "page",
    parseAsInteger.withDefault(1).withOptions({ history: "replace" }),
  );

  const normalizeQuery = (value: unknown): string => {
    if (typeof value === "string") {
      return value;
    }
    if (typeof value === "number") {
      return value.toString();
    }
    if (value && typeof value === "object" && "target" in value) {
      const event = value as ChangeEvent<HTMLInputElement>;
      return event?.target?.value ?? "";
    }
    return "";
  };

  const handleOnClick = (value: unknown) => updateQueryValue(value);

  const handleOnKeyUp = (event: ChangeEvent<HTMLInputElement> | string) => updateQueryValue(event);

  const updateQueryValue = (event: ChangeEvent<HTMLInputElement> | string | unknown) => {
    const query = normalizeQuery(event);
    setQueryValue(query === "" ? null : query, { shallow: true });
    setPageValue(1, { shallow: true });
  };

  const handleOnClearSearchInput = () => {
    setQueryValue(null, { shallow: true });
    setPageValue(1, { shallow: true });
  };

  return (
    <AfaSearchInput
      id="searchValue"
      buttonAriaLabel={"Sök i Försäkringshandboken"}
      placeholder={"Sök i Försäkringshandboken"}
      fullWidth
      value={queryValue || ""}
      onChange={setQueryValue}
      onSearchButtonClick={handleOnClick}
      inputLabel="Sök i Försäkringshandboken"
      clearField={true}
      buttonClearAriaLabel={"Töm sökfältet"}
      onKeyUp={handleOnKeyUp}
      onClearButtonClick={handleOnClearSearchInput}
    />
  );
}
